var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHighschool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.558716,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F0F0F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 17.0587C18.5 16.2303 19.1716 15.5587 20 15.5587C20.8284 15.5587 21.5 16.2303 21.5 17.0587V24.0587C21.5 24.8871 20.8284 25.5587 20 25.5587C19.1716 25.5587 18.5 24.8871 18.5 24.0587V17.0587Z",
    fill: "#00AAEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighschool);
export default __webpack_public_path__ + "static/media/highschool.b45b936aed04149f40eeb20b1224f503.svg";
export { ForwardRef as ReactComponent };